export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5304.2e81fe69.jpg";